import { createAsyncThunk } from '@reduxjs/toolkit';

import type { FeedbackTipo } from '../types/negociacaoFeedbackTypes';
import { negociacaoFeedbackService } from './services';

export const fetchMinhaAvaliacao = createAsyncThunk<
  { conversaId: string; tipo: FeedbackTipo | null; justificativa: string | null },
  string,
  { rejectValue: string }
>('negociacaoFeedback/fetch', async (conversaId, { rejectWithValue }) => {
  try {
    const { tipo, justificativa } = await negociacaoFeedbackService.getMinhaAvaliacao(conversaId);
    return { conversaId, tipo, justificativa };
  } catch (error) {
    return rejectWithValue(error instanceof Error ? error.message : 'Erro ao carregar avaliação');
  }
});

export const registrarAvaliacao = createAsyncThunk<
  { conversaId: string; tipo: FeedbackTipo; justificativa: string | null },
  { conversaId: string; tipo: FeedbackTipo; justificativa: string | null },
  { rejectValue: string }
>(
  'negociacaoFeedback/registrar',
  async ({ conversaId, tipo, justificativa }, { rejectWithValue }) => {
    try {
      const saved = await negociacaoFeedbackService.registrar(conversaId, tipo, justificativa);
      return { conversaId, tipo: saved.tipo, justificativa: saved.justificativa };
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Erro ao registrar feedback');
    }
  },
);

export const removerAvaliacao = createAsyncThunk<
  { conversaId: string },
  string,
  { rejectValue: string }
>('negociacaoFeedback/remover', async (conversaId, { rejectWithValue }) => {
  try {
    await negociacaoFeedbackService.remover(conversaId);
    return { conversaId };
  } catch (error) {
    return rejectWithValue(error instanceof Error ? error.message : 'Erro ao remover feedback');
  }
});
